import {
    FETCH_MTOKNA_CONTACTS,
    CLEAN_MTOKNA_CONTACTS,
    DELETE_MTOKNA_CONTACT,
    UNSUBSCRIBE_MTOKNA_CONTACT,
    SUBSCRIBE_MTOKNA_CONTACT,
    SEND_CONTACTS,
} from '../actions/types';
import _ from "lodash";

const MTOKNA_CONTACTS_DEFAULT_STATE = {};

const MtoknaContactsReducer = (state = MTOKNA_CONTACTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_CONTACTS:
            return payload;

        case UNSUBSCRIBE_MTOKNA_CONTACT:
            return { ...state, items: _.map(state.items, item => {
                if (item.email === payload) {
                    item = { ...item, unsubscribe: 1 };
                }

                return item;
            }) };

        case SUBSCRIBE_MTOKNA_CONTACT:
            return { ...state, items: _.map(state.items, item => {
                if (item.email === payload) {
                    item = { ...item, unsubscribe: 0 };
                }

                return item;
            }) };

        case CLEAN_MTOKNA_CONTACTS:
        case DELETE_MTOKNA_CONTACT:
        case SEND_CONTACTS:
            return MTOKNA_CONTACTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaContactsReducer;
